<template>
  <div class="control-switch">
    <span>{{ title }}</span>
    <a-switch
      v-model="switchVal"
      @change="switchChange"
    />
    <em id="switch-tip">{{ txt }}</em>
    <switch-tip-dialog
      v-if="tabName==='wechat'"
      ref="switchDialog"
    >
      <div class="switch-tip-box">
        <div class="switch-tip">
          <i class="icon iconfont iconicon-test68" />
          <h4>{{ $t('message["1282"]') }}</h4>
          <p>{{ $t('message["1424"]') }}。</p>
          <a-button
            type="primary"
            @click="authorize"
          >
            {{ $t('message["601"]') }}
          </a-button>
          <a-button
            class="ml-16"
            @click="onReset"
          >
            {{ $t('message["1005"]') }}
          </a-button>
        </div>
      </div>
    </switch-tip-dialog>
    <switch-tip-dialog
      v-if="tabName==='dingtalk'"
      ref="switchDialog"
    >
      <div class="switch-tip-box">
        <div class="switch-tip">
          <i class="icon iconfont iconicon-test68" />
          <h4>{{ $t('message["1280"]') }}</h4>
          <p>{{ $t('message["1422"]') }}。</p>
          <a-button
            type="primary"
            @click="authorize"
          >
            {{ $t('message["601"]') }}
          </a-button>
          <a-button
            class="ml-16"
            @click="onReset"
          >
            {{ $t('message["1005"]') }}
          </a-button>
        </div>
      </div>
    </switch-tip-dialog>
    <switch-tip-dialog
      v-if="tabName==='sms'"
      ref="switchDialog"
    >
      <div class="switch-tip-box">
        <div class="switch-tip">
          <i class="icon iconfont iconicon-test68" />
          <h4>{{ $t('message["1281"]') }}</h4>
          <p>{{ $t('message["1423"]') }}。</p>
          <a-button
            type="primary"
            @click="authorize"
          >
            {{ $t('message["601"]') }}
          </a-button>
          <a-button
            class="ml-16"
            @click="onReset"
          >
            {{ $t('message["1005"]') }}
          </a-button>
        </div>
      </div>
    </switch-tip-dialog>
    <switch-tip-dialog
      v-if="tabName==='email'"
      ref="switchDialog"
    >
      <div class="switch-tip-box">
        <div class="switch-tip">
          <i class="icon iconfont iconicon-test68" />
          <h4>{{ $t('message["1283"]') }}</h4>
          <p>{{ $t('message["1425"]') }}。</p>
          <a-button
            type="primary"
            @click="authorize"
          >
            {{ $t('message["601"]') }}
          </a-button>
          <a-button
            class="ml-16"
            @click="onReset"
          >
            {{ $t('message["1005"]') }}
          </a-button>
        </div>
      </div>
    </switch-tip-dialog>
    <switch-tip-dialog
      v-if="tabName==='wechat' || (tabName==='dingtalk')"
      ref="upgradeTipDialog"
    >
      <div class="switch-tip-box">
        <div class="switch-tip">
          <i class="icon iconfont iconicon-test68" />
          <h4>{{ upgradeTip1[0] }}{{ upTxt }}{{ upgradeTip1[1] }}</h4>
          <p>{{ upgradeTip[0] }}{{ upTxt }}{{ upgradeTip[1] }}{{ upTxt }}{{ upgradeTip[2] }}</p>
          <a-button
            type="primary"
            @click="upgradeMethod"
          >
            {{ $t('message["1050"]') }}
          </a-button>
          <a-button
            class="ml-16"
            @click="onUpgradeReset"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </div>
    </switch-tip-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { getClassVal } from '../scripts'
import SwitchTipDialog from './SwitchTipDialog'
export default {
  components: {
    SwitchTipDialog
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      switchVal: false,
      txt: this.$t('message["1459"]'),
      comname: '',
      cid: 0
    }
  },
  computed: {
    ...mapState('config/notice', ['switchStatus', 'datas', 'tabName']),
    ...mapGetters('config/notice', ['currentData']),
    tid () {
      return this.$store.getters.tid
    },
    upTxt () {
      let txt = ''
      const { tabName } = this
      if (tabName === 'wechat') {
        txt = this.$t('message["720"]')
      } else if (tabName === 'dingtalk') {
        txt = this.$t('message["238"]')
      }
      return txt
    },
    upgradeTip () {
      return this.$t('message["174"]').split('|')
    },
    upgradeTip1 () {
      return this.$t('message["1279"]').split('|')
    }
  },
  mounted () {
    if (this.datas[this.tabName] && this.datas[this.tabName][0].switch === 0) {
      this.switchVal = false
    } else {
      this.switchVal = true
    }
    this.setTxt()
  },
  methods: {
    ...mapMutations('config/notice', ['setStatus']),
    ...mapActions('config/notice', ['switchisOpen', 'fetchDatas']),
    async switchChange () {
      const chain = await this.switchisOpen()
      chain.params({ 'class': getClassVal(this.tabName) })
        .onNetSuccess(async (raw) => {
          let res = raw.data
          if (!res.error) {
            // this.$message.success(this.$t('message["81"]') + '！')
            this.comname = res.baseinfo.comname
            this.cid = res.baseinfo.cid
            if (this.switchVal === true) {
              if (res.payload.type === 1) {
                this.dialogShowHide(true)
                this.switchVal = false
              } else if (res.payload.switch === 1) {
                this.$message.success(this.$t('message["81"]') + '！')
                this.switchVal = true
                this.setTxt()
                const chain = await this.fetchDatas()
                chain.fetch()
              }
            } else {
              this.$message.success(this.$t('message["81"]') + '！')
              this.setTxt()
              const chain = await this.fetchDatas()
              chain.fetch()
            }
          } else if (res.error === 1000) {
            this.upTipDialogShowHide(true)
            this.switchVal = false
          } else {
            this.switchVal = false
            this.$message.error(res.message)
          }
        })
        .config({ tip: false, warn: false })
        .fetch()
    },
    setTxt () {
      if (this.switchVal === false) {
        this.txt = this.$t('message["1459"]')
      } else {
        this.txt = this.$t('message["1466"]')
      }
    },
    dialogShowHide (b) {
      this.$refs.switchDialog.isDialogShow = b
    },
    upTipDialogShowHide (b) {
      this.$refs.upgradeTipDialog.isDialogShow = b
    },
    authorize () {
      this.switchVal = true
      this.setTxt()
      this.dialogShowHide(false)
      this.$router.replace({ name: 'OrgQw', query: { cid: this.cid, comname: this.comname, type: 'qwdd' } })
    },
    upgradeMethod () {
      this.upTipDialogShowHide(false)
      this.$router.push({ name: 'ServiceBuy', params: { tid: this.tid }, query: { type: 3 } })
    },
    onUpgradeReset () {
      this.switchVal = false
      this.upTipDialogShowHide(false)
    },
    onReset () {
      this.switchVal = false
      this.dialogShowHide(false)
    }
  }
}
</script>
<style lang="scss" scoped>
// .switch-tip-box {
//   padding: 0 12px;

//   .switch-tip {
//     position: relative;
//     padding-left: 32px;
//     font-size: 14px;
//     color: #666;
//     line-height: 24px;

//     .iconicon-test68 {
//       font-size: 24px;
//       position: absolute;
//       left: 0;
//       color:#f6a953
//     }

//     p {
//       margin-bottom: 16px;
//     }

//     h4 {
//       font-weight: bold;
//     }
//   }
// }

.control-switch {
  padding: 4px 0 20px;

  span {
    margin-right: 15px;
  }

  em {
    margin-left: 10px;
    color: #b3b3b3;
    font-style: normal;
  }
}
</style>
